export const TitleTranslation: { [key: string]: string } = {
  Asset: 'General.Assets',
  Vehicles: 'General.Vehicles',
  Users: 'General.Users',
  Trips: 'General.Trips',
  Statistics: 'General.Statistics',
  Poi: 'General.Poi',
  Reports: 'General.Reports',
  Fleet: 'General.Fleet',
  Emissions: 'General.Emissions',
  Settings: 'Main.Settings',
  'On-call': 'General.OnCall',
};
